import Icon from '../components/Icon.vue'

Icon.register({
  cubes: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488.6 250.2L392 214V105.5C392 90.5 382.7 77.1 368.6 71.8L268.6 34.3C260.5 31.2 251.5 31.2 243.3 34.3L143.3 71.8C129.2 77.1 119.9 90.5 119.9 105.5V214L23.3 250.2C9.3 255.5 0 268.9 0 283.9V394C0 407.6 7.7 420.1 19.9 426.2L119.9 476.2C130 481.3 142 481.3 152.1 476.2L256 424.2 359.9 476.2C370 481.3 382 481.3 392.1 476.2L492.1 426.2C504.3 420.1 512 407.6 512 394V283.9C512 268.9 502.7 255.5 488.6 250.2zM358 214.8L273 246.7V178.5L358 141.5V214.8zM154 104.1L256 65.9 358 104.1V104.7L256 146.1 154 104.7V104.1zM238 395.2L153 437.7V358.6L238 319.8V395.2zM238 283.2L136 324.6 34 283.2V282.6L136 244.4 238 282.6V283.2zM478 395.2L393 437.7V358.6L478 319.8V395.2zM478 283.2L376 324.6 274 283.2V282.6L376 244.4 478 282.6V283.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cubes.js
// module id = 7Pwk
// module chunks = 144